import React, { useState } from "react";
import { Button, Col, Container, Row, Table } from "react-bootstrap";
import { FaArrowLeft, FaBook, FaClipboard, FaList } from "react-icons/fa";
import { MdOutlineReceiptLong } from "react-icons/md";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const BookingSummaryScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  // const {
  //   selectedItems = [],
  //   companyName = "",
  //   outletAddress = "",
  // } = location.state || {};

  // const totalAmount = selectedItems.reduce(
  //   (sum, item) => sum + item.itemOfferPrice * item.quantity,
  //   0
  // );

  const [selectedItems, setSelectedItems] = useState({
    ...userInfo?.selectedItems,
  });

  return (
    <>
      {" "}
      <FaArrowLeft
        style={{
          color: "green",
          marginRight: "1rem",
          fontSize: "1.8rem",
        }}
        onClick={() => navigate(-1)}
      />
      <div>
        <div className="fixed-header">
          <Row
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Col xs="auto" className="d-flex align-items-start">
              <div>
                <h4 className="mb-1 header-title">
                  {userInfo?.outletsDetails &&
                    userInfo?.outletsDetails[0]?.companyId?.companyName}
                </h4>
                <small
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                  className="header-subtitle"
                >
                  {" "}
                  {userInfo?.outletsDetails &&
                    userInfo?.outletsDetails[0]?.companyId?.companyCity}
                </small>
                <br />
                <br />
                {!userInfo?.deliveryTo?.includes("undefined") && (
                  <p>Seat - {userInfo?.deliveryTo}</p>
                )}
              </div>
            </Col>{" "}
            <h6
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }}
              className="text-dark"
            >
              Complete your Booking
            </h6>
          </Row>

          <Row style={{ padding: " 0px 1rem" }}>
            <Col xs={12} className="delivery-alert">
              Review and Place your Order
            </Col>
          </Row>
        </div>
        <h4 style={{ color: "green", marginTop: "2rem" }}>Order Summary</h4>
        <Row
          style={{
            // alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "row",
            width: "100%",
            margin: "1px auto",
            textAlign: "center",
            // border: "1px solid",
            height: "50vh",
            overflow: "scroll",
            borderRadius: "5px",
          }}
        >
          <Table striped bordered hover>
            <thead className={`${userInfo.themeColor}ThemeThead`}>
              <tr key="table-header"></tr>
              <th>Items</th>
              <th>Price/Item</th>
              <th>Qty</th>
              <th>Tax</th>
              <th>Amount</th>
            </thead>
            <tbody>
              {Object.values(selectedItems).map((it) => (
                <tr key={it.itemId}>
                  <td>{it.itemName}</td>

                  <td>
                    <span style={{ textDecoration: "line-through" }}>
                      ₹{it.itemOriginalPrice}
                    </span>{" "}
                    ₹{it.itemOfferPrice - it.discountAmount}
                  </td>
                  <td>{it.selectedQuantity}</td>
                  <td>
                    {it.gstPercent > 0 && (
                      <>
                        {it.gstTax}
                        <br />
                        {`${it.gstPercent}%`}
                      </>
                    )}
                  </td>
                  <td>{it.totalSellingPrice}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          {userInfo?.outletsDetails[0]?.companyId?.separatePlaformFee && (
            <>
              {"Platform Fee 3% - Rs. "}
              {(
                Object.values(selectedItems).reduce(
                  (total, it) => total + it.totalSellingPrice,
                  0
                ) *
                ((userInfo?.outletsDetails[0]?.companyId?.separatePlaformFee
                  ? userInfo?.outletsDetails[0]?.companyId?.platformFee
                  : 0) /
                  100)
              ).toFixed(2)}
            </>
          )}
        </Row>
        <Row>
          <Col>
            Total with GST <br />
            <br />
            <h6 style={{ color: "black" }}>
              ₹
              {(selectedItems !== null || selectedItems !== undefined) &&
                (
                  Object.values(selectedItems)?.reduce(
                    (total, it) => total + it.totalSellingPrice,
                    0
                  ) +
                  Object.values(selectedItems)?.reduce(
                    (total, it) => total + it.totalSellingPrice,
                    0
                  ) *
                    ((userInfo?.outletsDetails[0]?.companyId?.separatePlaformFee
                      ? userInfo?.outletsDetails[0]?.companyId?.platformFee
                      : 0) /
                      100)
                ).toFixed(2)}{" "}
              |{" "}
              {(selectedItems !== null || selectedItems !== undefined) &&
                Object.values(selectedItems)?.reduce(
                  (total, it) => total + it.selectedQuantity,
                  0
                )}{" "}
              Items
            </h6>
          </Col>
          <Col xs="auto">
            <Button
              disabled={
                selectedItems && Object.values(selectedItems)?.length < 1
              }
              className="continue-btn"
              style={{
                fontSize: "1rem",
                padding: "0.8rem",
                backgroundColor: "orange",
                color: "black",
              }}
              onClick={() =>
                navigate("/login", {
                  // state: {
                  //   selectedItems,
                  //   companyName,
                  //   outletAddress,
                  // },
                })
              }
            >
              <strong>CONFIRM ORDER</strong>
            </Button>
          </Col>
        </Row>
        {/* Fixed Footer */}
        {/* <div className="fixed-footer footer-bar px-3">
          <Row className="justify-content-between align-items-center">
            <Col>
              <span className="footer-subtext">Total with GST</span>
              <div className="footer-total">
                <strong>
                  ₹ {totalAmount} | {selectedItems.length}{" "}
                  {selectedItems.length === 1 ? "item" : "items"}
                </strong>
              </div>
            </Col>
            <Col xs="auto">
              <Button
                className="continue-btn"
                onClick={() =>
                  navigate("/login", {
                    state: {
                      selectedItems,
                      companyName,
                      outletAddress,
                    },
                  })
                }
              >
                CONFIRM ORDER
              </Button>
            </Col>
          </Row>
          <p className="text-center  small mt-2" style={{ color: "black" }}>
            By continuing to Payment, you hereby agree with{" "}
            <a href="#" className="text-danger">
              T&C
            </a>
          </p>
        </div> */}
      </div>
    </>
  );
};
export default BookingSummaryScreen;
